// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 8px;
}

.search input {
    height: 40px;
    border: 2px solid #F7E987;
    border-radius: 30px;
    padding: 0 16px;
    font-size: 16px;
    background-color: #445069;
    margin-bottom: 20px;
    width: 25%;
    color: #fff;
}

.search::placeholder {
    color: #F7E987;
    opacity: 80%;
}

.content__heading {
    font-size: 32px;
    font-weight: bold;
    margin-top: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.restaurant-item__not__found {
    text-align: center;
    font-size: 32px;
    margin-top: 130px;
    margin-bottom: 200px;
}`, "",{"version":3,"sources":["webpack://./src/styles/favorite.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;AACxB","sourcesContent":[".search {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 8px;\n}\n\n.search input {\n    height: 40px;\n    border: 2px solid #F7E987;\n    border-radius: 30px;\n    padding: 0 16px;\n    font-size: 16px;\n    background-color: #445069;\n    margin-bottom: 20px;\n    width: 25%;\n    color: #fff;\n}\n\n.search::placeholder {\n    color: #F7E987;\n    opacity: 80%;\n}\n\n.content__heading {\n    font-size: 32px;\n    font-weight: bold;\n    margin-top: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.restaurant-item__not__found {\n    text-align: center;\n    font-size: 32px;\n    margin-top: 130px;\n    margin-bottom: 200px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
